import { render, staticRenderFns } from "./UploadStudyMaterialModal.vue?vue&type=template&id=daa4391c&"
import script from "./UploadStudyMaterialModal.vue?vue&type=script&lang=js&"
export * from "./UploadStudyMaterialModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadStudyMaterialModal.vue?vue&type=style&index=0&id=daa4391c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports